// extracted by mini-css-extract-plugin
export default {"commentBox":"index_commentBox_xJg3a"};